import 'react-loading-skeleton/dist/skeleton.css';
import { useApplicationsTableState } from '../../Context/ApplicationsTableState.context';
import styles from './TableLoader.module.css';
import { TableLoaderRow } from './TableLoaderRow/TableLoaderRow';

export const TableLoader = () => {
  const { table } = useApplicationsTableState();

  return (
    <div className={styles.container} data-testid="table-loader">
      <table className={styles.table}>
        <colgroup>
          {table.getHeaderGroups()[0].headers.map((header) => (
            <col key={header.id} style={{ width: header.getSize() }} />
          ))}
        </colgroup>
        <tbody>
          {Array.from({ length: 7 }).map((_, index) => (
            <TableLoaderRow key={index} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
